import { render, staticRenderFns } from "./ArticleSitemap.vue?vue&type=template&id=b2b312b4&scoped=true&"
import script from "./ArticleSitemap.vue?vue&type=script&lang=js&"
export * from "./ArticleSitemap.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSitemap.vue?vue&type=style&index=0&id=b2b312b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b312b4",
  null
  
)

export default component.exports